import { gql } from '@src/lib/gql'

export const UPSERT_USER_SKILL = gql`
  mutation AdvisorApplyUpsertUserSkill($input: UpsertUserSkillInput!) {
    upsertUserSkill(input: $input) {
      userSkill {
        id
        userSkillId
        skillId
        title
        userRoleKeys
        compensationTypeKeys
        deletedAt
        skill {
          id
          skillId
          title
        }
      }
    }
  }
`
